import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export const billingMessagingFiltersSlice = createSlice({
  name: "billingMessagingFilters",
  initialState: {},
  reducers: {
    setBillingMessagingFilters(
      state: Record<string, unknown>,
      action: PayloadAction<Partial<Record<string, unknown>>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateBillingMessagingFilters(
      state: Record<string, unknown>,
      action: PayloadAction<{ key: string; value: unknown }>,
    ): void {
      const { key, value } = action.payload;
      // eslint-disable-next-line no-param-reassign
      (state as Record<string, unknown>)[key] = value;
    },
    resetBillingMessagingFilters() {
      // eslint-disable-next-line no-param-reassign, no-unused-vars, @typescript-eslint/no-unused-vars
      return {};
    },
  },
});

export const communicationMessagingFiltersSlice = createSlice({
  name: "communicationMessagingFilters",
  initialState: {},
  reducers: {
    setCommunicationMessagingFilters(
      state: Record<string, unknown>,
      action: PayloadAction<Partial<Record<string, unknown>>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateCommunicationMessagingFilters(
      state: Record<string, unknown>,
      action: PayloadAction<{ key: string; value: unknown }>,
    ): void {
      const { key, value } = action.payload;
      // eslint-disable-next-line no-param-reassign
      (state as Record<string, unknown>)[key] = value;
    },
    resetCommunicationMessagingFilters() {
      // eslint-disable-next-line no-param-reassign, no-unused-vars, @typescript-eslint/no-unused-vars
      return {};
    },
  },
});

export const {
  setBillingMessagingFilters,
  updateBillingMessagingFilters,
  resetBillingMessagingFilters,
} = billingMessagingFiltersSlice.actions;

export const { reducer: billingMessagingFiltersReducer } =
  billingMessagingFiltersSlice;

export const {
  setCommunicationMessagingFilters,
  updateCommunicationMessagingFilters,
  resetCommunicationMessagingFilters,
} = communicationMessagingFiltersSlice.actions;

export const { reducer: communicationMessagingFiltersReducer } =
  communicationMessagingFiltersSlice;
